import React, { Component } from 'react';
import { Grid, Row, Col, Panel, ButtonToolbar, Button, Breadcrumb, Input } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import axios from 'axios';

import { FETCH_SHIP_METHOD_OPTIONS_URL, SHIP_METHOD_CHANGE_URL } from '../../../actions/url'; 

const styles = {
  container: {
    width: '100%',
    margin: '10px auto',
    display: 'flex',
    flexDirection: 'column',
  },
};

class ShipMethodModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      shipMethodList: [],
      selectedShipMethod: null,
    }
  }
  componentWillMount() {
    this.getShipMethodOptions();
  }

  getShipMethodOptions() {
    axios.get(
      FETCH_SHIP_METHOD_OPTIONS_URL,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        this.setState({
          shipMethodList: response.data,
        });
      });
  }
  
  handleSaveButtonClick = () => {
    let id = null;
    if (this.props.salesOrder[0].SalesOrder_id) {
      id = this.props.salesOrder[0].SalesOrder_id;
    }
    const ship_method = this.state.selectedShipMethod;
    axios.put(
      `${SHIP_METHOD_CHANGE_URL}${id}`,
      { shipping_method: ship_method },
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        alert(response.data);
        this.props.successSaved();
      }, (err) => {
        alert(err.data);
      });
  }

  renderSaveButton() {
    return (
      <div
        style={{
          width: '100%',
          marginTop: '5px',
          alighItems: 'center',
          textAlign: 'center',
        }}
      >
        <Button
          bsStyle="success"
          onClick={this.handleSaveButtonClick}
        >
          <Translate value="save" />
        </Button>
      </div>
    );
  }
  renderEachMethod(method) {
    return (
      <div>
        <input
          style={{ marginLeft: '20px' }}
          type="radio"
          name="paymentMethod"
          value={method.shipping_method}
          checked={this.state.selectedShipMethod === method.shipping_method}
          onChange={(e) => this.setState({ selectedShipMethod: e.currentTarget.value })}
        />
        <label
          style={{ fontSize: '18px' }}
          onClick={() => this.setState({ selectedShipMethod: method.shipping_method })}
        >
          {method.name}
        </label>
      </div>
    );
  }
  render() {
    return (
      <div style={styles.container}>
        {
          this.state.shipMethodList.map(method => {
            return (
              this.renderEachMethod(method)
            )
          })
        }
        { this.renderSaveButton() }
      </div>
    );
  }
}

export default ShipMethodModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Sales/components/ShipMethodModal.jsx